<!-- SPDX-License-Identifier: GPL-3.0-or-later -->
<script lang="ts">
  type Tone = 'neutral' | 'warning' | 'success' | 'danger';

  interface Props {
    tone?: Tone;
    pulse?: boolean;
  }

  let { tone = 'neutral', pulse = false }: Props = $props();

  const dot: Record<Tone, string> = {
    neutral: 'bg-slate-400',
    warning: 'bg-amber-400',
    success: 'bg-green-400',
    danger: 'bg-red-400',
  };
  const ring: Record<Tone, string> = {
    neutral: 'bg-slate-400/20',
    warning: 'bg-amber-400/20',
    success: 'bg-green-400/40',
    danger: 'bg-red-400/20',
  };
</script>

<span class="relative inline-block w-2 h-2" aria-hidden="true">
  <span class="absolute inset-0 rounded-full {ring[tone]} {pulse ? 'animate-ping' : ''}"></span>
  <span class="absolute inset-0 rounded-full {dot[tone]}"></span>
</span>
